import { render } from "./AllenView.vue?vue&type=template&id=9029d77e&scoped=true"
import script from "./AllenView.vue?vue&type=script&lang=js"
export * from "./AllenView.vue?vue&type=script&lang=js"

import "./AllenView.vue?vue&type=style&index=0&id=9029d77e&scoped=true&lang=css"
import "./AllenView.vue?vue&type=style&index=1&id=9029d77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9029d77e"]])

export default __exports__